import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import axiosMiddleware from 'redux-axios-middleware';
import userReducer from './user';
import axios from '../../config/axios';

const reducer = combineReducers({
  user: userReducer,
});

export default createStore(
  reducer,
  composeWithDevTools(
    applyMiddleware(
      thunk,
      axiosMiddleware(axios.defaultInstance),
    ),
  ),
);
